import React from 'react';
import { CAREERS_EMAIL } from '../../config/contact';
import './Careers.css';

const Careers = () => {
  const handleEmailClick = (role = '') => {
    const subject = role ? `TQS Application | ${role}` : 'TQS Application | ';
    const mailtoLink = `mailto:${CAREERS_EMAIL}?subject=${encodeURIComponent(subject)}`;
    window.location.href = mailtoLink;
  };

  const roles = [
    {
      title: 'Kalshi / Polymarket Trader (Generalist)',
      location: 'USA',
      type: 'Internship',
      description: 'Trade across diverse Kalshi prediction markets including economics, weather, and other event-based contracts. Apply systematic thinking to identify mispriced probabilities.',
      skills: ['Prediction Markets', 'Systematic Trading', 'Probabilistic Thinking', 'Python']
    },
    {
      title: 'Software Developer',
      location: 'USA',
      type: 'Internship',
      description: 'Build high-performance algorithmic trading systems, data pipelines, and research infrastructure. Develop systematic trading strategies and quantitative models using Python and/or C++.',
      skills: ['Python', 'C++', 'Low-Latency / Distributed Systems', 'High-Performance Computing']
    },
    {
      title: 'Politics Trader',
      location: 'USA',
      type: 'Internship',
      description: 'Analyze and trade political prediction markets. Apply quantitative methods to evaluate probabilities and market efficiency in election and policy markets.',
      skills: ['Politics Markets', 'Systematic Trading', 'Probabilistic Thinking', 'Python']
    },
    {
      title: 'Crypto Trader',
      location: 'USA',
      type: 'Internship',
      description: 'Trade cryptocurrency prediction markets and derivatives. Develop and implement trading strategies based on market dynamics and quantitative analysis.',
      skills: ['Crypto Markets', 'Systematic Trading', 'Probabilistic Thinking', 'Python']
    },
    {
      title: 'Sports Trader',
      location: 'USA',
      type: 'Internship',
      description: 'Trade live sports markets using systematic strategies and quantitative models. Work with real-time data and market signals to identify trading opportunities.',
      skills: ['Sports Markets', 'Systematic Trading', 'Probabilistic Thinking', 'Python']
    }
  ];

  return (
    <div className="careers-page">
      <div className="careers-hero">
        <div className="careers-hero-content">
          <h1>Join TQS</h1>
          <p className="careers-contact">
            Roles in USA. We are always on the lookout for curious and creative minds.
            <br />
            Please apply to any of our active roles below or reach out directly to{' '}
            <a href={`mailto:${CAREERS_EMAIL}`}>
              {CAREERS_EMAIL}
            </a>
          </p>
          <p className="careers-instructions">
            When applying, please include your resume and a brief explanation of why you're interested in the internship.
            <br />
            (As an early-stage startup, these are currently unpaid positions designed for students and early-career professionals seeking hands-on experience.)
          </p>
        </div>
      </div>

      <div className="careers-content">
        <div className="careers-container">
          <h2 className="careers-section-title">Currently Hiring</h2>
          <p className="careers-subtitle">Internship positions for the following roles:</p>

          <div className="roles-list">
            {roles.map((role, index) => (
              <div key={index} className="role-card">
                <div className="role-header">
                  <div>
                    <h3 className="role-title">{role.title}</h3>
                    <div className="role-meta">
                      <span className="role-location">{role.location}</span>
                      <span className="role-separator">•</span>
                      <span className="role-type">{role.type}</span>
                    </div>
                  </div>
                </div>
                
                <p className="role-description">{role.description}</p>
                
                {role.skills && (
                  <div className="role-skills">
                    {role.skills.map((skill, idx) => (
                      <span key={idx} className="skill-tag">{skill}</span>
                    ))}
                  </div>
                )}

                <button 
                  className="apply-btn"
                  onClick={() => handleEmailClick(role.title)}
                >
                  Apply via Email
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Careers;

